const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the admin Journeys list component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('journeyList', ['Application', 'AccessHelper', 'Journeys', '$translate', function (Application, AccessHelper, Journeys, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      currentView: '=',
      selected: '='
    },
    template: require('../../../templates/directives/journeys/journey-list.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.loading = true;
      
      self.viewObject = function(id) {
        Application.navigation.goTo('/host/journeys/' + id)
      }
      
      self.allowArchive = function() {
        return AccessHelper.isAllowed(['admin', 'journeys', 'archive'], null, ['admin', 'creator']);
      }

      self.allowCreate = function() {
        return AccessHelper.isAllowed(['admin', 'journeys', 'create'], null, ['admin', 'creator']);
      }

      self.paginate = {
        perPage: 10,
        page: 0,
        emptyPage: false,
        nextPage: async function () {
          this.page++;
          await checkForSearchAndLoad();
        },
        previousPage: async function () {
          if (this.emptyPage) {
            this.emptyPage = false;
          }
          this.page--;
          await checkForSearchAndLoad();
        }
      }

      self.editMenu = {
        visible: false,
        activeId: null,
        closeHandler: function(){
          self.editMenu.visible = false;
          self.editMenu.activeId = null;
        },
        clickHandler: function(i){
          if (self.editMenu.visible) {
            if (self.editMenu.activeId === i) {
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            } else {
              self.editMenu.activeId = i;
            }
          } else {
            self.editMenu.activeId = i;
            self.editMenu.visible = true;
          }
        },
      };
    
      self.load = async function(query) {
        try {
          const queryWithArchive = {...query, archived: self.navigation.currentTab === 'archived'};
          const list = await Journeys.find({
            page: self.paginate.page,
            perPage: self.paginate.perPage,
            query: queryWithArchive
          }).$promise;
          if (list.length < self.paginate.perPage) {
            self.paginate.emptyPage = true;
          }
          if (list.length === self.paginate.perPage) {
            self.paginate.emptyPage = false;
          }
          // handle hitting 'next' button when no more items exist
          if (list.length === 0 && self.paginate.page > 0) {
            self.paginate.emptyPage = true;
            self.paginate.page--;
            self.loading = false;
            $scope.$apply();
            return;
          } 
          self.objs = list;
          self.loading = false;
          $scope.$apply();
       } catch (err) {
          console.log(err);
       }
      }

      self.navigation = {
        currentTab: 'active',
        changeTab: async function(tab) {
          if (tab !== self.navigation.currentTab) {
            self.navigation.currentTab = tab;
            self.paginate.page = 0;
            await checkForSearchAndLoad(); 
          }
        }
      }

      self.journeySelectedToArchive = null;
      self.showArchiveModal = false;

      self.requestArchive = function(journey) {
        self.journeySelectedToArchive = journey;
        self.showArchiveModal = true;
      }

      self.cancelArchive = function() {
        self.showArchiveModal = false;
        self.journeySelectedToArchive = null;
      }

      self.archive = async function() {
        try {
          await Journeys.archive({subresource: self.journeySelectedToArchive._id}, {archived: true}).$promise;
          Application.messaging.addMessage({type: 'success', duration: 6, text: self.translations['edit.journey.archive_success']});
          await checkForSearchAndLoad();
        } catch (e) {
          console.log(e);
          Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['edit.journey.archive_error']});
        }
        self.showArchiveModal = false;
        self.editMenu.closeHandler();
        self.journeySelectedToArchive = null;
        $scope.$apply();
      }

      self.unarchive = async function(journeyId) {
        try {
          await Journeys.archive({subresource: journeyId}, {archived: false}).$promise;
          Application.messaging.addMessage({type: 'success', duration: 6, text: self.translations['edit.journey.unarchive_success']});
          await checkForSearchAndLoad();
        } catch (e) {
          console.log(e);
          Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['edit.journey.unarchive_error']});
        }
        self.editMenu.closeHandler();
        $scope.$apply();
      }

      self.search = {
        query: {},
        existingQuery: function() {
          // Checks to see if there is an existing query to include when paginating
          return Object.keys(self.search.query).length > 0;
        },
        onQuery: async function(items) {
          self.search.query = {};
          const objs = [];
          let text = '';
          items.forEach(item => {
            if (item._id) {
              objs.push(item._id)
            } else {
              text = item.title;
            }
          })

          if (objs.length) {
            this.query._id = objs;
          }
          if (text.length) {
            this.query.term = text;
          }

          self.paginate.page = 0;
          await self.load(self.search.query);
        },
      } 

      const checkForSearchAndLoad = async function() {
        if (self.search.existingQuery()) {
          await self.load(self.search.query);
        } else {
          await self.load();
        }
      }

      $translate([
        'edit.journey.archive_success',
        'edit.journey.archive_error',
        'edit.journey.unarchive_success',
        'edit.journey.unarchive_error'
      ]).then(async function(translations) {
        self.translations = translations;
        await self.load();
      })
    
    }],
    controllerAs: 'ctrl'
  };
}]);
